import React from "react";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
} from "react-router-dom";
import "./App.css";
import LoginPage from "./components/LoginPage";
import AdminLayout from "./components/AdminLayout";

import StaffLayout from "./components/StaffLayout";


import { Toaster } from "sonner";



import ProtectedRoute from "./components/ProtectedRoute";

import CustomersPage from "./components/CustomersPage";

import Dashboard from "./components/Dashboard";
import ScrollToTop from "./components/ScrollToTop";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";

import CustomerDetails from "./components/CustomerDetails";
import PaymentsCustomerDetails from "./components/PaymentsCustomerDetails";
import PaymentsPage from "./components/PaymentsPage";
import BalanceSheet from "./components/BalanceSheet";
import Reports from "./components/Reports";
import Admin from "./components/Admin";
import List from "./components/List";
import TypeManagement from "./components/TypeManagement";
import Notes from "./components/Notes";
import Expenses from "./components/Expenses";
import Advanced from "./components/Advanced";
import ClosedCustomerList from "./components/ClosedCustomersPage";
import PendingCustomersPage from "./components/PendingCustomersPage";
import OriginalAmountPage from "./components/OriginalAmountPage";
import Profit from "./components/Profit";
import StaffDashboard from "./components/StaffDashboard";
import StaffCustomersPage from "./components/StaffCustomerPage";
import AttendanceDashboard from "./components/AttendanceDashboard";

import DeductProfit from "./components/DeductProfit";
import TodayPending from "./components/TodayPending";




function App() {
  return (
    <Router>
      <Toaster position="top-right" />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<LoginPage />} />

        {/* Admin Routes with Nested Layout */}

        <Route
          path="/admin"
          element={
            <ProtectedRoute role="admin">
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard1" element={<Dashboard />} />

       
          <Route path="customers" element={<CustomersPage />} />
          <Route path="customers/:id" element={<CustomerDetails />} />
          <Route path="payments/:id" element={<PaymentsCustomerDetails />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="balance-sheet" element={<BalanceSheet />} />
          <Route path="reports" element={<Reports />} />
          <Route path="admin-console" element={<Admin />} />
          <Route path="list" element={<List />} />
          <Route path="types" element={<TypeManagement />} />
          <Route path="notes" element={<Notes />} />
          <Route path="expenses" element={<Expenses />} />
          <Route path="advance" element={<Advanced />} />
          <Route path="closed" element={<ClosedCustomerList />} />
          <Route path="pending" element={<PendingCustomersPage />} />
          <Route path="original" element={<OriginalAmountPage />} />
          <Route path="profit" element={<Profit />} />
          <Route path="attendance" element = {<AttendanceDashboard/>}/>

<Route path="deduct-profit" element={<DeductProfit />} />
<Route path="today-pending" element={<TodayPending />} />

          {/*  */}
        </Route>

        <Route
          path="/staff"
          element={
            <ProtectedRoute role="staff">
              <StaffLayout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard2" element={<StaffDashboard />} />
           <Route path="customers/:id" element={<CustomerDetails />} />
           <Route path="payments/:id" element={<PaymentsCustomerDetails />} />
          {/* <Route path="customers/:id" element={<StaffCustomerDetails />} /> */}
          <Route path="customers" element={<StaffCustomersPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="notes" element={<Notes />} />
          <Route path="advance" element={<Advanced />} />
          <Route path="closed" element={<ClosedCustomerList />} />
          <Route path="pending" element={<PendingCustomersPage />} />
          <Route path="original" element={<OriginalAmountPage />} />
          <Route path="list" element={<List />} />
          <Route path="expenses" element={<Expenses />} />
          <Route path="attendance" element = {<AttendanceDashboard/>}/>
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
